module.exports = __webpack_public_path__ + "img/avatar.47d83e09.jpg";